export function getLinkAccountRequestTone(status) {
  switch (String(status || "").toLowerCase()) {
    case "pending":
      return "warning";
    case "approved":
      return "success";
    case "rejected":
      return "danger";
    default:
      break;
  }

  return "neutral";
}
